import { useSelector } from "react-redux";
import xmlFormatter from "xml-formatter";
import { XMLDataGrid } from "./XMLDataGrid";
import { useEffect, useState } from "react";
import '../../assets/RulesDetails.css';

export default function RuleDetails() {
  const [viewGrid, setViewGrid] = useState(true);
  const rule = useSelector((state) => state.rules.selectedRule);
  console.log("Selected Rule in RuleDetails:", rule);
  const formattedXmlData = rule?.xmlData ? xmlFormatter(rule.xmlData) : '';
  const isGridData = formattedXmlData.startsWith('<vars>');

  const switchGrid = () => {
    setViewGrid(!viewGrid);
  }

  useEffect(() => {
    setViewGrid(true);
  }, [rule])

  return (
    <div className="h-screen overflow-y-auto bg-white p-2">
      <div className="w-full flex-1">
        {rule ? (
          <>
            <p className="text-left"><strong>ID:</strong> {rule.ruleID}</p>
            <p className="text-left"><strong>Name:</strong> {rule.ruleCaption}</p>
            <p className="text-left"><strong>Condition Expression:</strong> {rule.conditionExpression || ''}</p>
            <p className="text-left"><strong>Enabled:</strong> {rule.length == 0 ? '' : rule.enabled ? 'True' : 'False'}</p>
            <p className="text-left"><strong>Comment:</strong> {rule.comment || ''}</p>
            <p className="text-left"><strong>Data: </strong> 
            {isGridData && rule?.xmlData &&
             <button className="xml" onClick={switchGrid}>View {viewGrid ? 'XML' : 'Grid'}</button>
            }
            {rule.length == 0 ? '' : !rule?.xmlData && 'No Data'}
            </p>
            {isGridData && viewGrid && <XMLDataGrid xmlData={rule.xmlData} />}
            {(!viewGrid || !isGridData) && formattedXmlData &&
              <pre className="bg-gray-100 p-2 rounded text-sm text-left overflow-y-auto" >
                <code className="text-left text-gray-800">
                  {formattedXmlData || ''}
                </code>
              </pre>
            }
          </>
        ) : (
          <p className="text-left text-gray-500">No rule selected.</p>
        )}
      </div>
    </div>
  );
}